import * as React from 'react';
import CopyOutlined from './copy-outlined';
import CopyFilled from './copy-filled';
import type { IconCombinedProps } from './types';
const CopyCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CopyFilled ref={ref} {...rest} />;
  }
  return <CopyOutlined ref={ref} {...rest} />;
});
export default CopyCombined;